import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://hipobuy.study';

const seoData = {
  title: 'Hipobuy Spreadsheet – Outil de Gestion de Données Intelligent | Catalogue Mode & E-commerce',
  description: 'Découvrez Hipobuy Spreadsheet, la plateforme nouvelle génération de gestion de données pour le e-commerce. Explorez 14 catégories mode : Shoes, Hoodies, T-Shirts, Jackets et plus sur Kaspreadsheet.',
  keywords: 'hipobuy spreadsheet, tableur intelligent, gestion données e-commerce, kaspreadsheet, catalogue mode, automatisation spreadsheet, alternative Excel',
  canonicalUrl: `${SITE_URL}/`,
  ogTitle: 'Hipobuy Spreadsheet – La Nouvelle Génération de Gestion de Données',
  ogDescription: 'Automatisation intelligente, analyse avancée, interface moderne. Découvrez Hipobuy Spreadsheet sur Kaspreadsheet.',
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Hipobuy Spreadsheet',
  url: SITE_URL,
  description: 'Hipobuy Spreadsheet – Outil de gestion de données intelligent et moderne pour les professionnels du e-commerce. Catalogue de 14 catégories de produits mode.',
  inLanguage: 'fr',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://kaspreadsheet.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleCards from './components/ArticleCards';
import ProductShowcase from './components/ProductShowcase';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <SEOHead
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonicalUrl={seoData.canonicalUrl}
        ogTitle={seoData.ogTitle}
        ogDescription={seoData.ogDescription}
        ogType="website"
        schemaJsonLd={websiteSchema}
      />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <CategoryGrid />
      <ArticleCards />
      <ProductShowcase />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </main>
  );
}